import React, {useMemo} from 'react';
import { CoreTracking } from "../../../models/CoreTracking"
import GoogleUserTrackingOperationsMenu, { isGoogleUserTracking, isSynchedGoogleUserTracking } from './googleTrackingOperations/GoogleUserTrackingOperationsMenu';
import { FlowSyncAccessPolicy, isAuthorized } from '../../../models/FlowSyncAccessPolicy';
import { useSelector } from 'react-redux';
import EntraIdUserTrackingOperationsMenu, { isEntraIdUserTracking } from './entraIdTrackingOperations/EntraIdUserTrackingOperationsMenu';
import AsmUserTrackingOperationsMenu, { isAsmUserTracking } from './asmTrackingOperations/AsmUserTrackingOperationsMenu';
import OneRosterTrackingOperationsMenu, { isOneRosterTracking } from './oneRosterTrackingOperations/OneRosterTrackingOperationsMenu';
import { FlowSyncObjectType } from '../../../models/CoreModels';
import { RootState } from '../../../store/store';


enum TrackingType {
    Unknown = 0,
    GoogleUser,
    EntraIdUser,
    AsmUser,
    OneRoster,
}

interface TrackingOperationsProps {
    tracking: CoreTracking
    onClose?: (success: boolean) => void
    flowSyncObjectType?: FlowSyncObjectType
}

const TrackingOperations: React.FC<TrackingOperationsProps> = (props) => {
    const authorizedAccessPolicies = useSelector<RootState, FlowSyncAccessPolicy[]>(state => state.me.me?.authorizedAccessPolicies ?? []);
    const hasMappingPermission = isAuthorized(authorizedAccessPolicies, FlowSyncAccessPolicy.EDIT_INFORMATION);

    const trackingType = getTrackingType(props.tracking);

    switch (trackingType) {
        case TrackingType.GoogleUser:
            return <GoogleUserTrackingOperationsMenu tracking={props.tracking} onClose={props.onClose} disabled={!hasMappingPermission} />;
        case TrackingType.EntraIdUser:
            return <EntraIdUserTrackingOperationsMenu tracking={props.tracking} onClose={props.onClose} disabled={!hasMappingPermission} />;
        case TrackingType.AsmUser:
            return <AsmUserTrackingOperationsMenu tracking={props.tracking} onClose={props.onClose} disabled={!hasMappingPermission} />;
        case TrackingType.OneRoster:
            return <OneRosterTrackingOperationsMenu tracking={props.tracking} onClose={props.onClose} disabled={!hasMappingPermission} flowSyncObjectType={props.flowSyncObjectType} />;
        default:
            return null;
    }
}

const getTrackingType = (tracking: CoreTracking): TrackingType => {
    if (isGoogleUserTracking(tracking)) {
        return TrackingType.GoogleUser;
    }

    if(isSynchedGoogleUserTracking(tracking)){
        return TrackingType.GoogleUser;
    }

    if (isEntraIdUserTracking(tracking)) {
        return TrackingType.EntraIdUser;
    }

    if (isAsmUserTracking(tracking)) {
        return TrackingType.AsmUser;
    }

    if (isOneRosterTracking(tracking)) {
        return TrackingType.OneRoster;
    }

    return TrackingType.Unknown;
}

export default TrackingOperations;